import { useEffect, useMemo, useCallback } from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import ReactPaginate from 'react-paginate'
import { useMain } from '../../contexts/MainContext'

import api from '../../services/api'

import { Header } from '../../components/Header'
import { ModalAdd } from '../../components/ModalAdd'
import { ModalEdit } from '../../components/ModalEdit'
import { ModalDelete } from '../../components/ModalDelete'
import { Botao } from '../../components/Botao'

import Edit from '../../assets/edit.svg'
import Checked from '../../assets/checked.svg'
import Unchecked from '../../assets/unchecked.svg'
import Trash from '../../assets/trash.svg'

import banner1 from '../../assets/banner1.png'

import { Container, Title, Content, Table } from './styles'

export function LojaBanner() {
 const title = 'Lojas'
 const subtitle = 'Alterar Banner'

 const fields = useMemo(
  () => [
   {
    id: 'Banner',
    imagem: String,
    title: String,
    status: Number
   }
  ],
  []
 )

 const {
  bannersLoja,
  setBannersLoja,
  modalAdd,
  toggleModalAdd,
  modalEdit,
  toggleModalEdit,
  modalDelete,
  toggleModalDelete,
  id,
  setID,
  offset,
  limit,
  handlePageClick
 } = useMain()

 const pageCount = Math.ceil(bannersLoja.length / limit)

 const loadBannersLoja = useCallback(async () => {
  try {
   const response = await api.get('banners-loja')

   setBannersLoja(response.data)
  } catch (error) {
   console.log('Ocorreu um erro ao buscar o banner')
  }
 }, [setBannersLoja])

 useEffect(() => {
  loadBannersLoja()
 }, [loadBannersLoja])

 return (
  <>
   <ToastContainer />

   {modalAdd && (
    <ModalAdd
     isClose={toggleModalAdd}
     isLoad={loadBannersLoja}
     fields={fields}
     name="banners-loja"
     title="Banner"
    />
   )}
   {modalDelete && (
    <ModalDelete
     isClose={toggleModalDelete}
     isLoad={loadBannersLoja}
     id={id}
     name="banners-loja"
     title="Banner"
    />
   )}
   {modalEdit && (
    <ModalEdit
     isClose={toggleModalEdit}
     isLoad={loadBannersLoja}
     id={id}
     name="banners-loja"
     folder="bannersLoja"
     title="Banner"
    />
   )}

   <Header title={title} subtitle={subtitle} />

   <Container>
    <Title>Gerenciador de banners</Title>
    {bannersLoja.length <= 0 ? (
     <>Nenhum banner cadastrado.</>
    ) : (
     <>
      <Table>
       <thead>
        <tr>
         <th>Exibição</th>
         <th>Título do Banner</th>
         <th>Imagem</th>
         <th>Status</th>
         <th colSpan="3"></th>
        </tr>
       </thead>
       <tbody>
        {bannersLoja &&
         bannersLoja.slice(offset, offset + limit).map(banner => (
          <tr key={banner.id}>
           <td>{banner.id}</td>
           <td>{banner.title}</td>
           <td>
            <div>
             {banner.file ? (
              <img
               src={`${process.env.REACT_APP_IMAGE_URL}/uploads/bannersLoja/${banner.file}`}
               alt={banner.title}
              />
             ) : (
              ''
             )}
            </div>
           </td>
           <td>
            {banner.status === 1 ? (
             <img src={Checked} alt="Ativo" />
            ) : (
             <img src={Unchecked} alt="Inativo" />
            )}
           </td>
           <td onMouseDown={() => setID(banner.id)}>
            <img
             src={Edit}
             alt="Editar"
             title="Editar"
             onClick={toggleModalEdit}
            />
           </td>
           <td onMouseDown={() => setID(banner.id)}>
            <img
             src={Trash}
             alt="Deletar"
             title="Deletar"
             onClick={toggleModalDelete}
            />
           </td>
          </tr>
         ))}
       </tbody>
      </Table>

      <ReactPaginate
       previousLabel={'<'}
       nextLabel={'>'}
       pageCount={pageCount}
       onPageChange={handlePageClick}
       containerClassName={'pagination'}
       previousLinkClassName={'pagination__link'}
       nextLinkClassName={'pagination__link'}
       disabledClassName={'pagination__link--disabled'}
       activeClassName={'pagination__link--active'}
      />
     </>
    )}
   </Container>

   <Container>
    <Title>Especificações do banner</Title>
    <Content>
     <div>
      <img src={banner1} alt="Banner principal" />
      <h3>Banner Principal</h3>
      <p>Formato: 1920 x 650 pixels</p>
      <p>Tamanho: Máximo 1MB</p>
     </div>
    </Content>
   </Container>

   <Botao isOpen={toggleModalAdd} />
  </>
 )
}
